import React from "react";

function W3() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="326"
      height="2"
      fill="none"
      viewBox="0 0 326 2"
    >
      <path
        fill="#fff"
        fillRule="evenodd"
        d="M325.438 1.123H0V.31h325.438v.812z"
        clipRule="evenodd"
      ></path>
    </svg>
  );
}

export default W3;
